import { useLayoutEffect } from "react";


export const CssTypography = () => {
    useLayoutEffect(() => {
        import('./CssTypography.scss');
    }, []);

    return null;
};